









import {Component} from "vue-property-decorator"
import Vue from "vue"
import JdiContent from "@/components/JdiContent.vue"

import JdiHeading from "@/components/JdiHeading.vue"
import JdiStatus from "@/components/JdiStatus.vue"
import JdsCandidateBubble from "@/design-system/constructs/CandidateBubble/JdsCandidateBubble.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdiDocs from "@/components/JdiDocs.vue"

@Component({
    components: {JdiDocs, JdsCandidateBubble, JdiStatus, JdiHeading, JdiContent, JdiPreview}
})
export default class Color extends Vue {
}
